'use es6';

import { connect } from 'react-redux';
import { Component } from 'react';
import { scrollContainer } from 'LayoutBuilderUI/actions/userInterfaceActions';
import { getScrollContainer } from 'LayoutBuilderUI/utils/scrollPositionUtils';
import { DropPosition } from 'EmailEditorUI/redux/actions/types/layoutActions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withDropComponent(WrappedComponent) {
  class DropComponentHOC extends Component {
    constructor(props) {
      super(props);
      this.getElementRef = ref => {
        this.node = ref;
      };
      this.getRect = () => {
        if (!this.rect) {
          this.updateBoundingClientRect();
        }
        return this.rect;
      };
      this.updateBoundingClientRect = () => {
        if (!this.node) return;
        this.rect = this.node.getBoundingClientRect();
      };
      this.updateSnapPlaceholderPosition = (position, isVertical = false) => {
        if (this.state.snapPlaceholderPosition !== position || this.state.isVertical !== isVertical) {
          this.setState({
            snapPlaceholderPosition: position,
            isVertical
          });
        }
      };
      this.pollScrolling = lastScrollTop => {
        setTimeout(() => {
          const scrollContainerRef = getScrollContainer();
          if (scrollContainerRef && scrollContainerRef.scrollTop === lastScrollTop) {
            this.setState({
              scrolling: false
            });
            this.props.scrollContainer({
              top: 0,
              bottom: scrollContainerRef.offsetHeight,
              scrollTop: scrollContainerRef.scrollTop
            });
          } else {
            this.pollScrolling(scrollContainerRef.scrollTop);
          }
        }, 100);
      };
      this.scrollIntoView = () => {
        if (this.node) {
          this.setState({
            scrolling: true
          });
          const scrollContainerRef = getScrollContainer();
          this.node.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
          this.pollScrolling(scrollContainerRef.scrollTop);
        }
      };
      this.onDragEnter = () => {
        this.updateBoundingClientRect();
      };
      this.state = {
        snapPlaceholderPosition: DropPosition.BEFORE,
        isVertical: false,
        scrolling: false
      };
    }
    componentDidMount() {
      if (this.props.isSelected) {
        this.scrollIntoView();
      }
      this.updateBoundingClientRect();
    }
    shouldComponentUpdate(props, state) {
      return !state.scrolling;
    }
    componentDidUpdate(prevProps) {
      if (!prevProps.isSelected && this.props.isSelected) {
        this.scrollIntoView();
      }
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        getElementRef: this.getElementRef,
        getRect: this.getRect,
        onDragEnter: this.onDragEnter,
        isVerticalSnapPlaceholder: this.state.isVertical,
        updateSnapPlaceholderPosition: this.updateSnapPlaceholderPosition,
        snapPlaceholderPosition: this.state.snapPlaceholderPosition
      }));
    }
  }
  return connect(null, {
    scrollContainer
  })(DropComponentHOC);
}